export const encontrarModulo = (permisos, modulo, padre = null) => {
    for(const item of permisos) {
        if(!item) continue;

        if(!item?.childrens || item?.childrens?.length <= 0) {
            if(item?.name === modulo) return item;
        }

        for(const it of item?.childrens) {
            if(!it?.childrens || it?.childrens?.length <= 0) {
                if(it?.name === modulo) return it;
            }

            if(it?.name === padre) return it?.childrens?.find(c => c?.name === modulo);
        }
    }
}